import React, { CSSProperties } from "react";
import { Stack } from "react-bootstrap";

import "./UserAction.scss";

interface UserActionProps {
  icon: React.ReactNode;
  text?: string | number;
  handleUserAction?: () => void;
  textStyle?: CSSProperties;
}

export default function UserAction(props: UserActionProps) {
  const { icon, text, handleUserAction, textStyle } = props;

  return (
    <Stack
      as={handleUserAction ? "button" : "div"}
      className="UserAction"
      onClick={handleUserAction}
    >
      <div className="Icon">{icon}</div>
      <p className="Grotesk Text" style={textStyle}>
        {text}
      </p>
    </Stack>
  );
}
